export default "__VITE_ASSET__DIctYzE7__"